import { useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import BarChart from "components/barChart";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { HiOutlineEye } from "react-icons/hi";
import GraphShadowIcon from "components/graph-shadow-icon";
import "../../styles/subscription.css";
import ModalComponent from "components/modal-component";
import { AiOutlineClose } from "react-icons/ai";
import Logo from "../../assets/images/logo.svg";
import {
  DashboardQuery,
  SubCompanyPagination,
  SubscriptionCompany,
  SubscriptionPercentage,
  SubscriptionSummaryTotal,
} from "model/dashboardModel";
import {
  // useDeleteCompanyMutation,
  useGetSubscriptionCompanyQuery,
  useGetSubscriptionPercentageQuery,
} from "api/dashboardApi";
import { useDeleteCompanyMutation } from "api/config/externalApi";
import { FormattedDateTime } from "components/formatted-date";
import emptyFile from "../../assets/images/emptydata.gif";
import {
  showToastError,
  showToastSuccess,
} from "components/toastify/ToastNotifications";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import info from "../../assets/images/info.gif";
import { FaBuilding } from "react-icons/fa";
import { SiSpotify } from "react-icons/si";

type Props = {
  summaryData: any;
  customDate: any;
  refresh: boolean;
};

const tableData = [
  {
    id: 1,
    companyName: "Zarttech Technologies",
    activeSeats: "4,503",
    monthlyRevenue: "€15,000",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        className="company-icon"
        style={{
          backgroundColor: "#FF6B35",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: "bold",
        }}
      >
        ZT
      </div>
    ),
  },
  {
    id: 2,
    companyName: "Spotify Music",
    activeSeats: "3,690",
    monthlyRevenue: "€12,000",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        style={{
          backgroundColor: "#1DB954",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <SiSpotify size={20} />
      </div>
    ),
  },
  {
    id: 3,
    companyName: "Figma Solutions",
    activeSeats: "3,399",
    monthlyRevenue: "€10,000",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: "🎨",
  },
  {
    id: 4,
    companyName: "Chase Bank Limited",
    activeSeats: "3,204",
    monthlyRevenue: "€8,500",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        style={{
          backgroundColor: "#0066B2",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <FaBuilding size={18} />
      </div>
    ),
  },
  {
    id: 5,
    companyName: "Zarttech Technologies",
    activeSeats: "3,106",
    monthlyRevenue: "€7,200",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        className="company-icon"
        style={{
          backgroundColor: "#FF6B35",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: "bold",
        }}
      >
        ZT
      </div>
    ),
  },
  {
    id: 6,
    companyName: "Spotify Music",
    activeSeats: "2,988",
    monthlyRevenue: "€6,000",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        style={{
          backgroundColor: "#1DB954",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <SiSpotify size={20} />
      </div>
    ),
  },
  {
    id: 7,
    companyName: "Figma Solutions",
    activeSeats: "2,974",
    monthlyRevenue: "€7,200",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: "🎨",
  },
  {
    id: 8,
    companyName: "Chase Bank Limited",
    activeSeats: "2,955",
    monthlyRevenue: "€7,200",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        style={{
          backgroundColor: "#0066B2",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <FaBuilding size={18} />
      </div>
    ),
  },
  {
    id: 9,
    companyName: "Zarttech Technologies",
    activeSeats: "2,927",
    monthlyRevenue: "€7,200",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        className="company-icon"
        style={{
          backgroundColor: "#FF6B35",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: "bold",
        }}
      >
        ZT
      </div>
    ),
  },
  {
    id: 10,
    companyName: "Spotify Music",
    activeSeats: "2,505",
    monthlyRevenue: "€7,200",
    staffSize: "50 - 200",
    totalSeats: "5,019",
    logo: (
      <div
        style={{
          backgroundColor: "#1DB954",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <SiSpotify size={20} />
      </div>
    ),
  },
];

const GeneralSummary = ({ summaryData, customDate, refresh }: Props) => {
  const [loading, setLoading] = useState(false);
  const [smallLoading, setSmallLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [activityTab, setActivityTab] = useState("Subscribers");
  const [activePlan, setActivePlan] = useState("All");
  // const [activeUser, setActiveUser] = useState("All");
  //Comment this out so that thdhdhd
  const [selectedCompany, setSelectedCompany] = useState<SubscriptionCompany>();
  const [show, setShow] = useState(false);
  const [smallShow, setSmallShow] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState("history");

  const [subSummaryTotal, setSubSummaryTotal] =
    useState<SubscriptionSummaryTotal>();

  let query: DashboardQuery = {
    application: summaryData?.selectedPackage,
    periodFilter:
      summaryData?.subMenuSearch === "OneMonth" ||
      summaryData?.subMenuSearch === "ThreeMonths" ||
      summaryData?.subMenuSearch === "OneYear" ||
      summaryData?.subMenuSearch === "AllTime" ||
      summaryData?.subMenuSearch === "Custom"
        ? summaryData?.subMenuSearch
        : "AllTime",
    fromDate: customDate?.startDate,
    toDate: customDate?.endDate,
  };

  const [isTableVisible, setIsTableVisible] = useState(true);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const handleRowSelection = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  //Use the useGetAllTicketQuery hook with the query object
  // const { data: getSubSummary, error: getSubSummaryError, isFetching: getSubSummaryisFetching } = useGetSubscriptionSummaryQuery(query);

  // useEffect(() => {
  //     if (getSubSummaryisFetching) {
  //         setLoading(true);
  //     }
  //     else {
  //         setLoading(false);
  //         if (getSubSummaryError) {
  //             showToastError('Unable to fetch data from the server');
  //         }
  //         else {
  //             setSubSummaryTotal(getSubSummary?.data as SubscriptionSummaryTotal);
  //         }
  //     }
  // }, [getSubSummaryisFetching, summaryData]);

  const [subSummaryPercentage, setSubSummaryPercentage] =
    useState<SubscriptionPercentage>();
  const {
    data: getSubSummaryPercentage,
    error: getSubSummaryPercentageError,
    isFetching: getSubSummaryPercentageisFetching,
    refetch: getSubSummaryPercentageRefetching,
  } = useGetSubscriptionPercentageQuery(query);

  useEffect(() => {
    if (getSubSummaryPercentageisFetching) {
      setLoading(true);
    } else {
      setLoading(false);
      if (getSubSummaryPercentageError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setSubSummaryPercentage(
          getSubSummaryPercentage?.data as SubscriptionPercentage
        );
      }
    }
  }, [getSubSummaryPercentageisFetching, summaryData, refresh]);

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [queryParameters, setQueryParameters] = useState<DashboardQuery>({
    application: summaryData?.selectedPackage,
    periodFilter:
      summaryData?.subMenuSearch === "OneMonth" ||
      summaryData?.subMenuSearch === "ThreeMonths" ||
      summaryData?.subMenuSearch === "OneYear" ||
      summaryData?.subMenuSearch === "AllTime" ||
      summaryData?.subMenuSearch === "Custom"
        ? summaryData?.subMenuSearch
        : "AllTime",
    page: pageNumber,
    pageSize: 10,
  });
  // let queryParameters: DashboardQuery = {
  //     application: summaryData?.selectedPackage,
  //     periodFilter: summaryData?.subMenuSearch === 'OneMonth' || summaryData?.subMenuSearch === 'ThreeMonths' || summaryData?.subMenuSearch === 'OneYear' || summaryData?.subMenuSearch === 'AllTime' || summaryData?.subMenuSearch === 'Custom' ? summaryData?.subMenuSearch : 'OneMonth',
  //     page: pageNumber,
  //     pageSize: 10,
  // };

  const [subCompanyPagination, setSubCompanyPagination] =
    useState<SubCompanyPagination>();
  const [subCompany, setSubCompany] = useState<SubscriptionCompany[]>([]);
  const [subCompanyFilter, setSubCompanyFilter] = useState<
    SubscriptionCompany[]
  >([]);
  const {
    data: getSubCompany,
    error: getSubCompanyError,
    isFetching: getSubCompanyisFetching,
    refetch: refetchSubCompany,
  } = useGetSubscriptionCompanyQuery(queryParameters);

  useEffect(() => {
    if (getSubCompanyisFetching) {
      setLoadingTable(true);
    } else {
      if (getSubCompanyError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setSubCompanyPagination(getSubCompany?.data as SubCompanyPagination);
        setSubCompany(getSubCompany?.data?.items as SubscriptionCompany[]);
        setSubCompanyFilter(
          getSubCompany?.data?.items as SubscriptionCompany[]
        );
      }
      setLoadingTable(false);
    }
  }, [getSubCompanyisFetching, summaryData, refresh]);

  // Function to handle page change
  const onPageChange = async (page: number) => {
    setQueryParameters((prev) => ({ ...prev, page: page }));
    // You can perform actions like fetching data for the new page here
  };

  useEffect(() => {
    refetchSubCompany();
    getSubSummaryPercentageRefetching();
  }, [queryParameters?.page]);

  const trendDates = ["Most Recent", "Lowest First", "Company Staff Size"];

  const chartCountName =
    subSummaryPercentage &&
    subSummaryPercentage?.plans?.map((item) => item?.name);
  const chartSubCount =
    subSummaryPercentage &&
    subSummaryPercentage?.plans?.map((item) => item?.subscriptionCount);

  const subscription = {
    options: {
      chart: { id: "basic-bar", stacked: true },
      plotOptions: {
        bar: { borderRadius: 5, horizontal: true, barHeight: "50%" },
      },
      dataLabels: { enabled: false },
      xaxis: { categories: chartCountName || [0, 0, 0, 0] },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 80, maxWidth: 150 },
      },
      fill: { colors: ["#219653", "rgba(33, 150, 83, 1)"] },
      tooltip: { enabled: false },
    },
    series: [
      {
        name: "Active subscribers",
        data: chartSubCount || [0, 0, 0, 0],
        color: "#219653",
      },
      {
        name: "All time subscribers",
        data: chartSubCount || [0, 0, 0, 0],
        color: "rgba(33, 150, 83, 0.15)",
      },
    ],
    type: "bar",
    width: 500,
    height: 300,
  };

  const revenue = {
    options: {
      chart: { id: "basic-bar", stacked: true },
      plotOptions: {
        bar: { borderRadius: 5, horizontal: true, barHeight: "50%" },
      },
      dataLabels: { enabled: false },
      xaxis: { categories: chartCountName || [0, 0, 0, 0] },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 80, maxWidth: 150 },
      },
      fill: { colors: ["#21A600", "rgba(33, 150, 83, 0.1)"] },
      tooltip: { enabled: false },
    },
    series: [
      {
        name: "Projects created",
        data: chartSubCount || [0, 0, 0, 0],
        color: "#21A600",
      },
      {
        name: "Estimated Project creation",
        data: chartSubCount || [0, 0, 0, 0],
        color: "rgba(33, 150, 83, 0.1)",
      },
    ],
    type: "bar",
    width: 600,
    height: 300,
  };

  const handleFilter = (product: any) => {
    setActivePlan(product);
    if (product) {
      setSubCompanyFilter(
        subCompany?.filter((item) => item?.planName === product)
      );
    }
  };

  const [menuopen, setMenuopen] = useState<boolean>(false);
  const [selected, setSelected] = useState<any[]>([]);
  const addSelected = (val: any) => {
    const sel = selected || [];
    let k = sel.find((v) => v.email === val.email);
    k ? sel.splice(sel.indexOf(k), 1) : sel.push(val);
    setSelected(() => [...sel]);
    
  };

  function handleDeleteCompany() {
    selected.map((k) => {
      deleteCompany(k.subdomain);
    });
  }

  const [deleteComp] = useDeleteCompanyMutation();

  const deleteCompany = async (subdomain: string) => {
    try {
      setSmallLoading(true);
      const response = await deleteComp(subdomain).unwrap();
      if (response) {
        setSmallLoading(false);
        showToastSuccess(response?.ResponseMessage);
        setSmallShow(false);
        refetchSubCompany();
      }
    } catch (error: any) {
      setSmallLoading(false);
      showToastError(
        error?.data.ResponseMessage || `Error deleting company ${subdomain}`
      );
    }
  };

  const totalSubscriptions = subSummaryPercentage?.plans?.reduce(
    (sum, plan) => sum + plan.subscriptionCount,
    0
  );

  const styles = {
    container: {
      padding: "20px",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      backgroundColor: "#f8f9fa",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      margin: "0",
      color: "#333",
    },
    hideButton: {
      backgroundColor: "transparent",
      border: "1px solid #6c757d",
      borderRadius: "20px",
      padding: "6px 16px",
      fontSize: "14px",
      color: "#6c757d",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    filterContainer: {
      display: "flex",
      gap: "8px",
      marginBottom: "24px",
      flexWrap: "wrap" as const,
    },
    filterButton: {
      padding: "8px 16px",
      border: "1px solid #6c757d",
      borderRadius: "20px",
      backgroundColor: "transparent",
      color: "#6c757d",
      fontSize: "14px",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    activeFilterButton: {
      padding: "8px 16px",
      border: "1px solid #007bff",
      borderRadius: "20px",
      backgroundColor: "#007bff",
      color: "white",
      fontSize: "14px",
      cursor: "pointer",
    },
    tableContainer: {
      backgroundColor: "white",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse" as const,
      margin: "0",
    },
    thead: {
      backgroundColor: "#f8f9fa",
    },
    th: {
      padding: "16px 12px",
      textAlign: "left" as const,
      fontSize: "14px",
      color: "#6c757d",
      fontWeight: "500",
      borderBottom: "none",
    },
    td: {
      padding: "16px 12px",
      borderBottom: "1px solid #f1f3f4",
      fontSize: "14px",
    },
    companyCell: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    logo: {
      width: "40px",
      height: "40px",
      backgroundColor: "#f8f9fa",
      border: "1px solid #e9ecef",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
    },
    checkbox: {
      width: "16px",
      height: "16px",
      cursor: "pointer",
    },
    pagination: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "20px",
    },
    paginationButtons: {
      display: "flex",
      gap: "4px",
    },
    pageButton: {
      width: "32px",
      height: "32px",
      border: "none",
      backgroundColor: "transparent",
      color: "#6c757d",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
    },
    activePageButton: {
      width: "32px",
      height: "32px",
      border: "none",
      backgroundColor: "#007bff",
      color: "white",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
    },
    hiddenState: {
      textAlign: "center" as const,
      padding: "60px 0",
      color: "#6c757d",
    },
  };

  if (!isTableVisible) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <h6 style={styles.title}>All SaaS Seats Details</h6>
          <button
            style={styles.hideButton}
            onClick={() => setIsTableVisible(true)}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#f8f9fa";
              e.currentTarget.style.borderColor = "#007bff";
              e.currentTarget.style.color = "#007bff";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "#6c757d";
              e.currentTarget.style.color = "#6c757d";
            }}
          >
            Show Table ↓
          </button>
        </div>
        <div style={styles.hiddenState}>
          <p>Table is hidden. Click "Show Table" to display the data.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4">
      <h5 className="fw-bold mb-4">SaaS Seats</h5>
      {loading ? (
        <div style={{ textAlign: "center", padding: "3rem", margin: "auto" }}>
          <Spinner />
          <br />
          <h4>loading...</h4>
        </div>
      ) : (
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ flex: 1, marginRight: "1rem" }}>
            {activityTab === "Subscribers" && (
              <div
                style={{
                  padding: "1.5rem 2rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                    {summaryData?.selectedPackage} Subscription Activity{" "}
                    <BiDotsHorizontalRounded />
                  </span>
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      style={{
                        width: "75%",
                        borderRadius: "50px",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="d-flex align-items-end">
                  <h2 className="second-font">
                    {subSummaryPercentage?.totalCount?.toLocaleString()}
                  </h2>
                  <p className="dark-text ps-3">subscriptions</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <BarChart {...subscription} />
                </div>
              </div>
            )}

            {activityTab === "Revenue" && (
              <div
                style={{
                  padding: "1.5rem 2rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                    {summaryData?.selectedPackage} Revenue Activity{" "}
                    <BiDotsHorizontalRounded style={{ marginLeft: "1rem" }} />
                  </span>
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      style={{
                        width: "75%",
                        borderRadius: "50px",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    marginTop: "1rem",
                  }}
                >
                  <h2>
                    €{subSummaryPercentage?.totalRevenue?.toLocaleString()}
                  </h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <BarChart {...revenue} />
                </div>
              </div>
            )}
          </div>

          {/* Plans in a 2x2 Grid */}
          <div
            style={{
              flex: 1,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gridAutoRows: "140px",
              gap: "1rem",
              alignItems: "start",
            }}
          >
            {subSummaryPercentage?.plans?.map((item, key) => {
              const borderColors = ["#F49F0A", "#008CFE", "#219653"];
              const borderColor =
                borderColors[Math.floor(Math.random() * borderColors.length)];
              return (
                <div
                  key={key}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "0.6rem",
                    padding: "0.5rem 0.75rem", // smaller padding
                    display: "flex",
                    justifyContent: "space-between",
                    height: "140px", // keep fixed height
                    borderLeft: `6px solid ${borderColor}`,
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // center content vertically
                      gap: "0.12rem",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1.02rem",
                        fontWeight: 500,
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.name} Plan
                    </span>
                    <h2 style={{ margin: "0.12rem 0", lineHeight: 1.1 }}>
                      {item?.subscriptionCount}
                    </h2>
                    <span
                      style={{
                        color:
                          item?.percentageIncrement >= 0
                            ? "#219653"
                            : "#EB5757",
                        display: "flex",
                        alignItems: "center",
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.percentageIncrement >= 0 ? (
                        <FiArrowUpRight
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      ) : (
                        <FiArrowDownLeft
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      )}
                      {parseFloat(item?.percentageIncrement.toFixed(0))}% last
                      month
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "0.5rem",
                    }}
                  >
                    {item?.percentageIncrement >= 0 ? (
                      <GraphShadowIcon fillColor="#219653" />
                    ) : (
                      <GraphShadowIcon fillColor="#EB5757" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="my-4">
        <h6 className="first-font-medium">All SaaS Seats Details</h6>
        {loadingTable ? (
          <div className="text-center p-5 m-auto">
            <Spinner />
            <br /> <h4>loading...</h4>
          </div>
        ) : (
          <>
            <div className="my-4 position-relative">
              <button
                onClick={() => {
                  setSubCompanyFilter(subCompany);
                  setActivePlan("All");
                }}
                className={
                  activePlan === "All"
                    ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3"
                    : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"
                }
              >
                Highest First
              </button>
              {trendDates?.map((product) => (
                <button
                  onClick={() => handleFilter(product)}
                  className={
                    activePlan === product
                      ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3"
                      : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"
                  }
                >
                  {product}
                </button>
              ))}
              {selected.length ? (
                <div className="position-absolute end-0 top-0">
                  <button className="btn-primary font-size-sm first-font-medium">
                    Manage Client
                  </button>
                  {menuopen ? (
                    <div
                      className="bg-white shadow-sm rounded-2 position-absolute mt-2"
                      style={{ width: "14em" }}
                    >
                      <div
                        className="d-flex align-items-center p-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSmallShow(true);
                          setActiveModalTab("delete");
                          setMenuopen(false);
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.3034 14.3034C15.7099 12.8968 16.5001 10.9892 16.5001 9.00005C16.5001 7.01091 15.7099 5.10324 14.3034 3.69671C12.8968 2.29018 10.9892 1.5 9.00005 1.5C7.01091 1.5 5.10324 2.29018 3.69671 3.69671M14.3034 14.3034C12.8968 15.7099 10.9892 16.5001 9.00005 16.5001C7.01091 16.5001 5.10324 15.7099 3.69671 14.3034C2.29018 12.8968 1.5 10.9892 1.5 9.00005C1.5 7.01091 2.29018 5.10324 3.69671 3.69671M14.3034 14.3034L3.69671 3.69671"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        &nbsp; Delete Accounts
                      </div>
                      <div
                        className="d-flex align-items-center p-2"
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.125 5.625V14.375C18.125 14.8723 17.9275 15.3492 17.5758 15.7008C17.2242 16.0525 16.7473 16.25 16.25 16.25H3.75C3.25272 16.25 2.77581 16.0525 2.42417 15.7008C2.07254 15.3492 1.875 14.8723 1.875 14.375V5.625M18.125 5.625C18.125 5.12772 17.9275 4.65081 17.5758 4.29917C17.2242 3.94754 16.7473 3.75 16.25 3.75H3.75C3.25272 3.75 2.77581 3.94754 2.42417 4.29917C2.07254 4.65081 1.875 5.12772 1.875 5.625M18.125 5.625V5.8275C18.125 6.14762 18.0431 6.46242 17.887 6.74191C17.7309 7.0214 17.5059 7.25628 17.2333 7.42417L10.9833 11.27C10.6877 11.4521 10.3472 11.5485 10 11.5485C9.65275 11.5485 9.31233 11.4521 9.01667 11.27L2.76667 7.425C2.4941 7.25711 2.26906 7.02224 2.11297 6.74275C1.95689 6.46325 1.87496 6.14845 1.875 5.82833V5.625"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        &nbsp; Send Update/Message
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
            {subCompany?.length > 0 ? (
              <>
                <Table responsive className="table">
                  <thead style={styles.thead}>
                    <tr>
                      <th style={{ ...styles.th, width: "50px" }}>
                        <input
                          type="checkbox"
                          style={styles.checkbox}
                          checked={selectedRows.length === tableData.length}
                        />
                      </th>
                      <th style={styles.th}>SN ↓</th>
                      <th style={{ ...styles.th, width: "60px" }}></th>
                      <th style={styles.th}>Company Name ↓</th>
                      <th style={styles.th}>Active Seats ↓</th>
                      <th style={styles.th}>Monthly Revenue ↓</th>
                      <th style={styles.th}>Staff Size</th>
                      <th style={styles.th}>Total Seats ↓</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={row.id}>
                        <td style={styles.td}>
                          <input
                            type="checkbox"
                            style={styles.checkbox}
                            checked={selectedRows.includes(row.id)}
                            onChange={() => handleRowSelection(row.id)}
                          />
                        </td>
                        <td
                          style={{
                            ...styles.td,
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {index + 1}.
                        </td>
                        <td style={styles.td}>
                          <div style={styles.logo}>{row.logo}</div>
                        </td>
                        <td
                          style={{
                            ...styles.td,
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {row.companyName}
                        </td>
                        <td
                          style={{
                            ...styles.td,
                            color: "#333",
                          }}
                        >
                          {row.activeSeats}
                        </td>
                        <td
                          style={{
                            ...styles.td,
                            color: "#333",
                          }}
                        >
                          {row.monthlyRevenue}
                        </td>
                        <td style={{ ...styles.td, color: "#6c757d" }}>
                          {row.staffSize}
                        </td>
                        <td style={{ ...styles.td, color: "#6c757d" }}>
                          {row.totalSeats}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="text-end py-3">
                  <Pagination
                    current={subCompanyPagination?.pageNumber || 0}
                    total={subCompanyPagination?.totalSize}
                    pageSize={subCompanyPagination?.pageSize}
                    onChange={onPageChange}
                  />
                </div>

                <button className="btn-secondary-outline font-size-sm first-font-medium px-3 w-100">
                  Hide
                </button>
              </>
            ) : (
              <div className="p-5 text-center fs-5">
                <img src={emptyFile} width="200px" />
                <h6>No data available</h6>
              </div>
            )}
          </>
        )}
      </div>
      <ModalComponent
        size={undefined}
        showModal={smallShow}
        hideModal={() => setSmallShow(false)}
      >
        {activeModalTab === "delete" && (
          <div className="px-3">
            <div className="my-3 text-center">
              <img src={info} width="120px" />
            </div>
            <p className="fs-5 fw-bold">
              Confirm deletion of selected Company(ies)
            </p>
            <p className="text-secondary">
              Are you sure you want to delete the selected company(ies)? <br />
              Removing this company(ies) would remove all access and history on
              JobPro.
            </p>
            <div className="pt-3 pb-4">
              <button
                disabled={loading}
                type="button"
                onClick={() => handleDeleteCompany()}
                className="btn btn-danger w-100 border-0 py-3 rounded-5"
              >
                Confirm {smallLoading && <Spinner size="sm" />}
              </button>
            </div>
          </div>
        )}
      </ModalComponent>

      <ModalComponent
        size="xl"
        showModal={show}
        hideModal={() => setShow(false)}
      >
        <div className="position-absolute w-100 p-3 mb-5">
          <p className="d-flex justify-content-end pb-4">
            <button className="btn p-0 ">
              <AiOutlineClose onClick={() => setShow(false)} size={20} />
            </button>
          </p>
        </div>
        <div className="px-4 py-5">
          <div className="mt-3 mb-5">
            <span className="bg-white p-3 rounded-3">
              <img src={Logo} />
            </span>
          </div>
          {/* <div className='d-flex justify-content-between px-4 py-5'>
                        <div>
                            <button onClick={() => setActiveUser("All")} className={activeUser === "All" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3 py-2" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"}>All Users</button>
                            <button onClick={() => setActiveUser("Deactivated")} className={activeUser === "Deactivated" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3 py-2" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"}>Deactivated Employees</button>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <button onClick={() => setActiveUser("All")} className="btn-primary font-size-sm first-font-medium px-3 me-3 py-2"><FiPlus size={20} /> Invite Employee</button>
                            <button onClick={() => setActiveUser("Deactivated")} className="btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"><GoCircleSlash size={20} /> Suspend Employee</button>
                            <Form className='my-auto'>
                                <Form.Control type='text' placeholder='Search' className='rounded-4 search-input light-text' />
                            </Form>
                        </div>
                    </div> */}

          {activeModalTab === "history" && (
            <div>
              <Table responsive className="table">
                <thead>
                  <tr>
                    <th>
                      <label className="fw-normal">SN</label>
                    </th>
                    <th>
                      <label className="fw-normal">Company Name</label>
                    </th>
                    <th>
                      <label className="fw-normal">Country</label>
                    </th>
                    <th>
                      <label className="fw-normal">Email</label>
                    </th>
                    <th>
                      <label className="fw-normal">Plan</label>
                    </th>
                    <th>
                      <label className="fw-normal">Registration Date</label>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="align-middle">
                    <td>
                      <Form.Check />
                    </td>
                    <td>{selectedCompany?.companyName}</td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.country}
                      </span>
                    </td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.email}
                      </span>
                    </td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.planName}
                      </span>
                    </td>
                    {/* <td><span className='text-secondary'>{selectedCompany?.staffSize}</span></td> */}
                    <td>
                      <span className="text-secondary">
                        {FormattedDateTime(
                          selectedCompany?.registrationDate || ""
                        )}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </ModalComponent>

      {loading ? (
        <div className="text-center p-5 m-auto">
          <Spinner />
          <br /> <h4>loading...</h4>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-6">
            {activityTab === "Subscribers" && (
              <div className="subscription py-4 px-5 bg-white rounded-4">
                <div className="d-flex justify-content-between">
                  <span className="font-size-mid first-font-medium">
                    Seat Growth Trends <BiDotsHorizontalRounded />
                  </span>
                  <div className="w-50 d-flex align-item-end justify-content-end">
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      className="w-75 rounded-5"
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="d-flex align-items-end">
                  <h2 className="second-font">
                    {subSummaryPercentage?.totalCount?.toLocaleString()}
                  </h2>
                  <p className="dark-text ps-3">created so far</p>
                </div>
                <div className="d-flex align-item-center justify-content-center text-center">
                  <BarChart {...subscription} />
                </div>
              </div>
            )}
            {activityTab === "Revenue" && (
              <div className="revenue py-4 px-5 bg-white rounded-4">
                <div className="d-flex justify-content-between">
                  <span className="font-size-mid first-font-medium">
                    {summaryData?.selectedPackage} Revenue Activity{" "}
                    <BiDotsHorizontalRounded className="ms-4" />
                  </span>
                  <div className="w-50 d-flex align-item-end justify-content-end">
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      className="w-75 rounded-5"
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="d-flex align-items-end">
                  <h2 className="second-font">
                    €{subSummaryPercentage?.totalRevenue?.toLocaleString()}
                  </h2>
                  {/* <p className='dark-text ps-3'>this month</p> */}
                </div>
                <div className="d-flex align-item-center justify-content-center text-center">
                  <BarChart {...revenue} />
                </div>
              </div>
            )}
          </div>
          {/* jhghgv */}
          <div
            style={{
              flex: 1,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gridAutoRows: "140px",
              gap: "1rem",
              alignItems: "start",
            }}
          >
            {subSummaryPercentage?.plans?.map((item, key) => {
              const borderColors = ["#F49F0A", "#008CFE", "#219653"];
              const borderColor =
                borderColors[Math.floor(Math.random() * borderColors.length)];
              return (
                <div
                  key={key}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "0.6rem",
                    padding: "0.5rem 0.75rem", // smaller padding
                    display: "flex",
                    justifyContent: "space-between",
                    height: "140px", // keep fixed height
                    borderLeft: `6px solid ${borderColor}`,
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // center content vertically
                      gap: "0.12rem",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1.02rem",
                        fontWeight: 500,
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.name} Plan
                    </span>
                    <h2 style={{ margin: "0.12rem 0", lineHeight: 1.1 }}>
                      {item?.subscriptionCount}
                    </h2>
                    <span
                      style={{
                        color:
                          item?.percentageIncrement >= 0
                            ? "#219653"
                            : "#EB5757",
                        display: "flex",
                        alignItems: "center",
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.percentageIncrement >= 0 ? (
                        <FiArrowUpRight
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      ) : (
                        <FiArrowDownLeft
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      )}
                      {parseFloat(item?.percentageIncrement.toFixed(0))}% last
                      month
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "0.5rem",
                    }}
                  >
                    {item?.percentageIncrement >= 0 ? (
                      <GraphShadowIcon fillColor="#219653" />
                    ) : (
                      <GraphShadowIcon fillColor="#EB5757" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralSummary;

